import Ajax from '../../../../util/ajax';
export function zigbeeImageNotify(nid, eid, payload) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch, true);
        const url = '/zigbee/' + nid + '/ep/' + eid + '/cluster/25/command/image-notify';
        const value = {
            'jitter': payload.jitter
        };
        ajax.post(url, value);
    };
}
